import React from 'react';
import { Selector } from './Selector/Selector';
import { useSettings } from '../../../../providers/SettingsProvider';
import { useTexts } from '../../../../useTexts';
export const QualitySelector = _ref => {
  let {
    visible,
    onBackButtonClick
  } = _ref;
  const {
    menuQualityTitle
  } = useTexts();
  const {
    qualityState
  } = useSettings();
  if (!qualityState) {
    return null;
  }
  const {
    qualities,
    selectedQuality,
    setQualityLevel
  } = qualityState;
  const options = qualities.map(quality => ({
    displayText: quality.name,
    value: quality.level
  }));
  return /*#__PURE__*/React.createElement(Selector, {
    visible: visible,
    onBackButtonClick: onBackButtonClick,
    options: options,
    onSelect: setQualityLevel,
    selectedValue: selectedQuality.level,
    backButtonText: menuQualityTitle
  });
};
//# sourceMappingURL=QualitySelector.js.map